import { Row, Table } from 'antd'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { Pagination, UserImg } from 'components/display'
import { Text } from 'components/typo'
import { format, helper } from 'utils'

function LifeBridgeTable(props) {
  const navigate = useNavigate()

  const pagination = props.page ? (
    <Pagination page={props.page} onChange={props.onChange} />
  ) : undefined

  return (
    <Container className={props.className}>
      <Row justify="end">
        <Text xsmall color="#A0A3BD">
          {props.page?.total || '0'} รายการ
        </Text>
      </Row>
      <StyledTable
        scroll={{ x: 830 }}
        dataSource={props.data}
        columns={[
          {
            title: 'หน่วย',
            dataIndex: 'company_affiliation_name',
            key: 'company_affiliation_name',
            width: 170,
            render: (text) => text || '-',
          },
          {
            title: 'จังหวัด',
            dataIndex: 'province_name_th',
            key: 'province_name_th',
            width: 140,
            render: (text) => text || '-',
          },
          {
            title: 'หัวหน้าทีม',
            dataIndex: 'agent',
            key: 'agent',
            width: 160,
            render: (_, row) =>
              row.life_bridge_agent_id ? (
                <div>
                  <Avatar
                    img_url={row.img_url}
                    size="27px"
                    gender={row.agent?.gender || null}
                  />
                  <Text xsmall>{`${row.firstname} ${row.lastname}`}</Text>
                </div>
              ) : (
                '-'
              ),
          },
          {
            title: 'วันที่สร้าง',
            dataIndex: 'created_date',
            key: 'created_date',
            width: 120,
            render: (text) =>
              helper.isValue(text) ? format.toShortThaiDate(text) : '-',
          },
          {
            title: 'วันอัพเดต',
            dataIndex: 'updated_date',
            key: 'updated_date',
            width: 120,
            render: (text) =>
              helper.isValue(text) ? format.toShortThaiDate(text) : '-',
          },
          {
            title: 'สมาชิก',
            dataIndex: 'members_count',
            key: 'members_count',
            width: 120,
            render: (text) => text || '-',
          },
        ]}
        loading={props.loading}
        onRow={(record) => {
          return {
            onClick: (e) => {
              navigate(`/life-bridge/${record.company_affiliation_id}`)
            },
          }
        }}
        pagination={false}
      />
      <Row justify="end" lg={24}>
        {pagination}
      </Row>
    </Container>
  )
}

const Container = styled.div`
  margin-bottom: 2rem;
`

const StyledTable = styled(Table)`
  margin-bottom: 1rem;
`

const Avatar = styled(UserImg)`
  margin-right: 0.5rem;
`

export default LifeBridgeTable
